package components.Spacer

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 13.10.22
 * Author : marcusspors
 */

import csstype.number
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.useState


external interface SpacerProps : Props {
    var flexGrow: Double?
    var mOnClick: () -> Unit
}

val Spacer = FC<SpacerProps> { props ->

    val mFlexGrow by useState(props.flexGrow ?: 1.0)

    ReactHTML.div {
        css {
            flexGrow = number(mFlexGrow)
        }
        onClick = {
            props.mOnClick()
        }
    }

}
